<template>
  <div
    ref="kt_modal_faturamento_editar_declaracao_importacao"
    data-bs-backdrop="static"
    data-bs-focus="false"
    class="modal fade modal-overlay"
    tabindex="-1"
    id="kt_modal_faturamento_editar_declaracao_importacao"
    data-bs-keyboard="false"
  >
    <div
      class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-header">
          <div class="card-title d-flex align-items-center">
            <span class="svg-icon svg-icon-1 svg-icon me-3 lh-0">
              <inline-svg src="media/icons/duotune/general/gen005.svg" />
            </span>
            <h3 class="fw-bold m-0 text-gray-800">Declaração de Importação</h3>
          </div>
          <div
            class="btn btn-icon btn-sm btn-active-light-primary"
            @click="cancelar()"
          >
            <span class="svg-icon svg-icon-1 svg-icon lh-0">
              <inline-svg src="media/icons/duotune/arrows/arr061.svg" />
            </span>
          </div>
        </div>
        <div class="modal-body p-5">
          <div class="row">
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-8 fv-row mb-6"
            >
              <label class="form-label"
                >Número do Documento de Importação</label
              >
              <input
                type="text"
                id="txtnDI"
                :class="[
                  'form-control mb-2',
                  errosValidacao['nDI'] ? 'is-invalid' : '',
                ]"
                v-model="this.refDI.nDI"
                maxlength="12"
              />
              <div class="fv-plugins-message-container invalid-feedback">
                {{ errosValidacao["nDI"] }}
              </div>
            </div>
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-4 fv-row mb-6"
            >
              <label class="form-label">Data de Registro da DI</label>
              <el-date-picker
                id="dtpRegistro"
                v-model="this.refDI.dDI"
                type="datetime"
                name="dtpRegistro"
                placeholder="Selecione uma data"
                class="w-100"
                format="DD/MM/YYYY"
                size="large"
                @keydown.stop.prevent.enter=""
                :class="{ 'is-invalid': errosValidacao.dDI }"
              />
              <div class="fv-plugins-message-container invalid-feedback">
                {{ errosValidacao["dDI"] }}
              </div>
            </div>
          </div>
          <div class="row">
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-9 fv-row mb-6"
            >
              <label class="form-label">Local do desembaraço</label>
              <input
                type="text"
                id="txtXLocDesemb"
                :class="[
                  'form-control mb-2',
                  errosValidacao['xLocDesemb'] ? 'is-invalid' : '',
                ]"
                v-model="this.refDI.xLocDesemb"
                maxlength="60"
              />
              <div class="fv-plugins-message-container invalid-feedback">
                {{ errosValidacao["xLocDesemb"] }}
              </div>
            </div>
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-3 fv-row mb-6"
            >
              <label class="form-label">UF desembaraço</label>
              <select
                :class="[
                  'form-select',
                  errosValidacao['UFDesemb'] ? 'is-invalid' : '',
                ]"
                v-model="this.refDI.UFDesemb"
              >
                <option value="AC">Acre</option>
                <option value="AL">Alagoas</option>
                <option value="AP">Amapá</option>
                <option value="AM">Amazonas</option>
                <option value="BA">Bahia</option>
                <option value="CE">Ceara</option>
                <option value="DF">Distrito Federal</option>
                <option value="ES">Espirito Santo</option>
                <option value="GO">Goiás</option>
                <option value="MA">Maranhão</option>
                <option value="MT">Mato Grosso</option>
                <option value="MS">Mato Grosso do Sul</option>
                <option value="MG">Minas Gerais</option>
                <option value="PA">Para</option>
                <option value="PB">Paraíba</option>
                <option value="PR">Paraná</option>
                <option value="PE">Pernambuco</option>
                <option value="PI">Piauí</option>
                <option value="RJ">Rio de Janeiro</option>
                <option value="RN">Rio Grande do Norte</option>
                <option value="RS">Rio Grande do Sul</option>
                <option value="RO">Rondônia</option>
                <option value="RR">Roraima</option>
                <option value="SC">Santa Catarina</option>
                <option value="SP">São Paulo</option>
                <option value="SE">Sergipe</option>
                <option value="TO">Tocantins</option>
              </select>
              <div class="fv-plugins-message-container invalid-feedback">
                {{ errosValidacao["UFDesemb"] }}
              </div>
            </div>
          </div>
          <div class="row">
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-4 fv-row mb-6"
            >
              <label class="form-label">Data do desembaraço</label>
              <el-date-picker
                id="dtpDDesemb"
                v-model="this.refDI.dDesemb"
                type="datetime"
                name="dtpDDesemb"
                placeholder="Selecione uma data"
                class="w-100"
                format="DD/MM/YYYY"
                size="large"
                @keydown.stop.prevent.enter=""
                :class="{ 'is-invalid': errosValidacao.dDesemb }"
              />
              <div class="fv-plugins-message-container invalid-feedback">
                {{ errosValidacao["dDesemb"] }}
              </div>
            </div>
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-5 fv-row mb-6"
            >
              <label class="form-label">Código Exportador</label>
              <input
                type="text"
                id="txtcExportador"
                :class="[
                  'form-control mb-2',
                  errosValidacao['cExportador'] ? 'is-invalid' : '',
                ]"
                v-model="this.refDI.cExportador"
                maxlength="60"
              />
              <div class="fv-plugins-message-container invalid-feedback">
                {{ errosValidacao["cExportador"] }}
              </div>
            </div>
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-3 fv-row mb-6"
            >
              <label class="form-label">Valor da AFRMM</label>
              <CurrencyInput
                class="form-control mb-2 text-danger"
                placeholder="Valor da AFRMM"
                style="text-align: right"
                v-model="this.refDI.vAFRMM"
                :options="options"
                :class="[
                  'form-control mb-2',
                  errosValidacao['vAFRMM'] ? 'is-invalid' : '',
                ]"
              ></CurrencyInput>
              <div class="fv-plugins-message-container invalid-feedback">
                {{ errosValidacao["vAFRMM"] }}
              </div>
            </div>
          </div>
          <div class="row">
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6 fv-row mb-6"
            >
              <label class="form-label">Via de Transporte</label>
              <select
                :class="[
                  'form-select',
                  errosValidacao['tpViaTransp'] ? 'is-invalid' : '',
                ]"
                v-model="this.refDI.tpViaTransp"
              >
                <option value="1">1 - Marítima</option>
                <option value="2">2 - Fluvial</option>
                <option value="3">3 - Lacustre</option>
                <option value="4">4 - Aérea</option>
                <option value="5">5 - Postal</option>
                <option value="6">6 - Ferroviária</option>
                <option value="7">7 - Rodoviária</option>
                <option value="8">8 - Conduto / Rede Transmissão</option>
                <option value="9">9 - Meios Próprios</option>
                <option value="10">10 - Entrada / Saída ficta</option>
                <option value="11">11 - Courier</option>
                <option value="12">12 - Handcarry</option>
              </select>
              <div class="fv-plugins-message-container invalid-feedback">
                {{ errosValidacao["tpViaTransp"] }}
              </div>
            </div>
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6 fv-row mb-6"
            >
              <label class="form-label">Tipo Intermediação</label>
              <select
                :class="[
                  'form-select',
                  errosValidacao['tpIntermedio'] ? 'is-invalid' : '',
                ]"
                v-model="this.refDI.tpIntermedio"
              >
                <option value="1">1 - Importação por conta própria</option>
                <option value="2">2 - Importação por conta e ordem</option>
                <option value="3">3 - Importação por encomenda</option>
              </select>
              <div class="fv-plugins-message-container invalid-feedback">
                {{ errosValidacao["tpIntermedio"] }}
              </div>
            </div>
          </div>
          <div
            class="row"
            v-if="
              this.refDI.tpIntermedio &&
              (this.refDI.tpIntermedio == '2' || this.refDI.tpIntermedio == '3')
            "
          >
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-9 fv-row mb-6"
            >
              <label class="form-label">CNPJ do adquirente</label>
              <input
                type="text"
                id="txtCNPJ"
                :class="[
                  'form-control mb-2',
                  errosValidacao['CNPJ'] ? 'is-invalid' : '',
                ]"
                v-model="this.refDI.CNPJ"
                v-mask="['##.###.###/####-##']"
              />
              <div class="fv-plugins-message-container invalid-feedback">
                {{ errosValidacao["CNPJ"] }}
              </div>
            </div>
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-3 fv-row mb-6"
            >
              <label class="form-label">UF do adquirente</label>
              <select
                :class="[
                  'form-select',
                  errosValidacao['UFTerceiro'] ? 'is-invalid' : '',
                ]"
                v-model="this.refDI.UFTerceiro"
              >
                <option value="AC">Acre</option>
                <option value="AL">Alagoas</option>
                <option value="AP">Amapá</option>
                <option value="AM">Amazonas</option>
                <option value="BA">Bahia</option>
                <option value="CE">Ceara</option>
                <option value="DF">Distrito Federal</option>
                <option value="ES">Espirito Santo</option>
                <option value="GO">Goiás</option>
                <option value="MA">Maranhão</option>
                <option value="MT">Mato Grosso</option>
                <option value="MS">Mato Grosso do Sul</option>
                <option value="MG">Minas Gerais</option>
                <option value="PA">Para</option>
                <option value="PB">Paraíba</option>
                <option value="PR">Paraná</option>
                <option value="PE">Pernambuco</option>
                <option value="PI">Piauí</option>
                <option value="RJ">Rio de Janeiro</option>
                <option value="RN">Rio Grande do Norte</option>
                <option value="RS">Rio Grande do Sul</option>
                <option value="RO">Rondônia</option>
                <option value="RR">Roraima</option>
                <option value="SC">Santa Catarina</option>
                <option value="SP">São Paulo</option>
                <option value="SE">Sergipe</option>
                <option value="TO">Tocantins</option>
              </select>
              <div class="fv-plugins-message-container invalid-feedback">
                {{ errosValidacao["UFTerceiro"] }}
              </div>
            </div>
          </div>
          <div class="d-flex flex-column mb-5 mx-0">
            <div
              :class="[
                'card card-bordered',
                errosValidacao['adi'] ? 'border-danger' : '',
              ]"
            >
              <div class="card-header bg-light min-h-50px">
                <h3 class="card-title align-items-start flex-column">
                  <span class="card-label fw-bolder fs-3 mb-1">Adições</span>
                  <span class="text-muted mt-1 fw-bold fs-7"
                    >Mínimo 1 e máximo 100 registros</span
                  >
                </h3>
                <div class="card-toolbar">
                  <div
                    class="d-flex justify-content-end"
                    data-kt-customer-table-toolbar="base"
                  >
                    <button
                      @click="adicionarFaturamentoAdicoesDeclaracaoImportacao()"
                      type="button"
                      class="btn btn-sm btn-primary btn-active-primary"
                    >
                      <span class="svg-icon svg-icon-1">
                        <inline-svg
                          src="media/icons/duotune/arrows/arr075.svg" /></span
                      >Adicionar
                    </button>
                  </div>
                </div>
              </div>
              <div class="card-body pt-2 pb-2">
                <div class="table-responsive">
                  <table
                    :class="[loadingAdicoes && 'overlay overlay-block']"
                    class="table table-row-dashed table-row-gray-300 fs-6 align-middle gs-0 gy-2 fw-bold dataTable no-footer table-hover"
                    id="kt_table_dai_declaracao_importacao"
                  >
                    <thead>
                      <tr class="fw-bolder text-muted">
                        <th>Item</th>
                        <th>Nº Adição</th>
                        <th>Cód. Fabricante</th>
                        <th>Valor do Desconto</th>
                        <th>Nº Drawback</th>
                        <th class="min-w-100px text-end">Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      <template v-if="this.refDI.adi.length > 0">
                        <template v-for="(adi, i) in this.refDI.adi" :key="i">
                          <tr>
                            <td>
                              <div class="align-middle">
                                <div>
                                  <span
                                    class="text-dark text-hover-primary mb-1"
                                  >
                                    {{ i + 1 }}
                                  </span>
                                </div>
                              </div>
                            </td>
                            <td>
                              <div class="align-middle">
                                <div>
                                  <span
                                    class="text-dark text-hover-primary mb-1"
                                  >
                                    {{ adi.nAdicao }}
                                  </span>
                                </div>
                              </div>
                            </td>
                            <td>
                              <div class="align-middle">
                                <div>
                                  <span
                                    class="text-dark text-hover-primary mb-1"
                                  >
                                    {{ adi.cFabricante }}
                                  </span>
                                </div>
                              </div>
                            </td>
                            <td>
                              <div class="align-middle">
                                <div>
                                  <span
                                    class="text-dark text-hover-primary mb-1"
                                  >
                                    {{
                                      this.$utils.formatarNumeroCasas(
                                        adi.vDescDI,
                                        2
                                      )
                                    }}
                                  </span>
                                </div>
                              </div>
                            </td>
                            <td>
                              <div class="align-middle">
                                <div>
                                  <span
                                    class="text-dark text-hover-primary mb-1"
                                  >
                                    {{ adi.nDraw }}
                                  </span>
                                </div>
                              </div>
                            </td>
                            <td
                              class="d-flex justify-content-end flex-shrink-0"
                            >
                              <button
                                class="btn btn-icon btn-bg-light btn-active-primary btn-sm me-1"
                                @click="
                                  editarFaturamentoAdicoesDeclaracaoImportacao(
                                    i
                                  )
                                "
                              >
                                <span class="svg-icon svg-icon-5 m-0">
                                  <inline-svg
                                    src="media/icons/duotune/art/art005.svg"
                                  />
                                </span>
                              </button>
                              <button
                                class="btn btn-icon btn-bg-light btn-active-danger btn-sm me-1"
                                @click="
                                  removerFaturamentoAdicoesDeclaracaoImportacao(
                                    i
                                  )
                                "
                              >
                                <span class="svg-icon svg-icon-5 m-0">
                                  <inline-svg
                                    src="media/icons/duotune/general/gen027.svg"
                                  />
                                </span>
                              </button>
                            </td>
                          </tr>
                        </template>
                      </template>
                      <template v-else>
                        <tr class="odd">
                          <td :colSpan="12" class="dataTables_empty">
                            {{ "Sem registros" }}
                          </td>
                        </tr>
                      </template>
                    </tbody>
                    <div
                      v-if="loadingAdicoes"
                      class="overlay-layer card-rounded bg-dark bg-opacity-5"
                    >
                      <div
                        class="spinner-border text-primary"
                        role="status"
                      ></div>
                      <span class="ms-2">Aguarde, carregando...</span>
                    </div>
                  </table>
                </div>
              </div>
            </div>
            <div class="fv-plugins-message-container invalid-feedback">
              {{ errosValidacao["adi"] }}
            </div>
          </div>
        </div>
        <div class="modal-footer d-flex justify-content-end">
          <button
            class="btn btn-danger svg-icon-white me-2 mb-2"
            @click="cancelar()"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg
                src="media/icons/duotune/arrows/arr015.svg"
                class="me-2"
              />Cancelar
            </span>
          </button>
          <button
            class="btn btn-success svg-icon-white mb-2"
            @click="confirmar()"
            v-bind:data-kt-indicator="this.loading ? 'on' : 'off'"
          >
            <span class="indicator-progress">
              <span
                class="spinner-border spinner-border-sm align-middle ms-1"
              ></span>
              Aguarde...
            </span>
            <span class="svg-icon svg-icon-1" v-if="!this.loading">
              <inline-svg
                src="media/icons/duotune/arrows/arr016.svg"
                class="me-2"
              />Confirmar
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
  <FaturamentoEditarAdicoesDeclaracaoImportacao
    v-if="exibirFaturamentoEditarAdicoesDeclaracaoImportacao"
    :index="indexFaturamentoAdicoesDeclaracaoImportacao"
    :refADIFaturamento="this.adicoesDeclaracaoImportacaoAtual"
    @exibirModalEditarAdicoesDeclaracaoImportacao="
      modalFaturamentoEditarAdicoesDeclaracaoImportacao
    "
    @adicionarAdicoesDeclaracaoImportacao="adicionarAdicoesDeclaracaoImportacao"
    @editarAdicoesDeclaracaoImportacao="editarAdicoesDeclaracaoImportacao"
  ></FaturamentoEditarAdicoesDeclaracaoImportacao>
</template>

<script>
import { useToast } from "vue-toastification";
import { MenuComponent } from "@/assets/ts/components";
import { getOrCreateInstanceModal } from "@/core/helpers/dom";
import { hideModal } from "@/core/helpers/dom";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import CurrencyInput from "@/components/text/CurrencyInput";
import FaturamentoEditarAdicoesDeclaracaoImportacao from "@/views/faturamento/FaturamentoEditarAdicoesDeclaracaoImportacao.vue";

const toast = useToast();

const refDIInicializado = {
  nDI: "",
  dDI: null,
  xLocDesemb: "",
  UFDesemb: "",
  dDesemb: null,
  tpViaTransp: "",
  vAFRMM: 0,
  tpIntermedio: "",
  CNPJ: "",
  UFTerceiro: "",
  cExportador: "",
  adi: [],
};

export default {
  components: { CurrencyInput, FaturamentoEditarAdicoesDeclaracaoImportacao },
  emits: [
    "exibirModalEditarDeclaracaoImportacao",
    "adicionarDeclaracaoImportacao",
    "editarDeclaracaoImportacao",
  ],
  props: {
    index: { type: Number, required: true, default: -1 },
    refDIFaturamento: { type: Object, required: true },
  },
  methods: {
    async confirmar() {
      this.errosValidacao = {};
      this.loading = true;

      if (this.validar() === true) {
        if (this.index === -1) {
          this.$emit("adicionarDeclaracaoImportacao", this.refDI);
        } else {
          this.$emit("editarDeclaracaoImportacao", this.refDI, this.index);
        }
        hideModal(this.$refs.kt_modal_faturamento_editar_declaracao_importacao);
        this.$emit("exibirModalEditarDeclaracaoImportacao", false);
      } else {
        await this.$swal.showInvalidAlert("Verifique os avisos!");
      }

      this.loading = false;
    },
    validar() {
      let result = true;

      if (!this.refDI.nDI) {
        this.errosValidacao.nDI = "O número do documento é invalido";
        result = false;
      } else if (this.refDI.nDI.trim().length <= 0) {
        this.errosValidacao.nDI = "O número do documento é invalido";
        result = false;
      }

      if (!this.refDI.dDI) {
        this.errosValidacao.dDI = "A data de registro é inválida";
        result = false;
      }

      if (!this.refDI.xLocDesemb) {
        this.errosValidacao.xLocDesemb = "O local de desembaraço é inválido";
        result = false;
      } else if (this.refDI.xLocDesemb.trim().length <= 0) {
        this.errosValidacao.xLocDesemb = "O local de desembaraço é inválido";
        result = false;
      }

      if (!this.refDI.UFDesemb) {
        this.errosValidacao.UFDesemb =
          "Selecione a UF onde ocorreu o Desembaraço";
        result = false;
      } else if (this.refDI.UFDesemb.trim().length <= 0) {
        this.errosValidacao.UFDesemb =
          "Selecione a UF onde ocorreu o Desembaraço";
        result = false;
      }

      if (!this.refDI.dDesemb) {
        this.errosValidacao.dDesemb =
          "A data do desembaraço não foi selecionada";
        result = false;
      }

      if (!this.refDI.tpViaTransp) {
        this.errosValidacao.tpViaTransp = "Selecione a via de transporte";
        result = false;
      } else if (this.refDI.tpViaTransp.trim().length <= 0) {
        this.errosValidacao.tpViaTransp = "Selecione a via de transporte";
        result = false;
      }

      if (this.refDI.tpViaTransp) {
        if (this.refDI.tpViaTransp == "1") {
          if (!this.refDI.vAFRMM) {
            this.errosValidacao.vAFRMM = "Informe o valor da AFRMM";
            result = false;
          }
        }
      }

      if (!this.refDI.tpIntermedio) {
        this.errosValidacao.tpIntermedio = "Selecione a forma de importação";
        result = false;
      } else if (this.refDI.tpIntermedio.trim().length <= 0) {
        this.errosValidacao.tpIntermedio = "Selecione a forma de importação";
        result = false;
      }

      if (this.refDI.tpIntermedio) {
        if (this.refDI.tpIntermedio == "2" || this.refDI.tpIntermedio == "3") {
          if (!this.refDI.CNPJ) {
            this.errosValidacao.CNPJ = "Informe o CNPJ do adquirente";
            result = false;
          } else if (this.refDI.CNPJ.trim().length <= 0) {
            this.errosValidacao.CNPJ = "Informe o CNPJ do adquirente";
            result = false;
          }

          if (!this.refDI.UFTerceiro) {
            this.errosValidacao.UFTerceiro = "Seleciona a UF do adquirente";
            result = false;
          } else if (this.refDI.UFTerceiro.trim().length <= 0) {
            this.errosValidacao.UFTerceiro = "Seleciona a UF do adquirente";
            result = false;
          }
        }
      }

      if (!this.refDI.cExportador) {
        this.errosValidacao.cExportador = "Informe o código do exportador";
        result = false;
      } else if (this.refDI.cExportador.trim().length <= 0) {
        this.errosValidacao.cExportador = "Informe o código do exportador";
        result = false;
      }

      if (this.refDI.adi.length <= 0) {
        this.errosValidacao.adi = "Informe ao menos uma adição";
        result = false;
      }

      return result;
    },
    cancelar() {
      hideModal(this.$refs.kt_modal_faturamento_editar_declaracao_importacao);
      this.$emit("exibirModalEditarDeclaracaoImportacao", false);
    },
    nextFocus(id) {
      if (document.getElementById(id) != null) {
        document.getElementById(id).focus();
      }
    },

    modalFaturamentoEditarAdicoesDeclaracaoImportacao(exibir) {
      this.exibirFaturamentoEditarAdicoesDeclaracaoImportacao = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_faturamento_editar_adicoes_declaracao_importacao",
          /*open*/ () => {
            this.$utils.requestFocus("txtnAdicao");
          },
          /*close*/ () => {
            this.modalFaturamentoEditarAdicoesDeclaracaoImportacao(false);
          }
        );
      }
    },
    async adicionarFaturamentoAdicoesDeclaracaoImportacao() {
      if (this.refDI.adi.length < 100) {
        this.indexFaturamentoAdicoesDeclaracaoImportacao = -1;
        this.adicoesDeclaracaoImportacaoAtual = [];
        this.modalFaturamentoEditarAdicoesDeclaracaoImportacao(true);
      } else {
        await this.$swal.showInvalidAlert(
          "Não é possível adicionar mais que 100 adições!"
        );
      }
    },
    editarFaturamentoAdicoesDeclaracaoImportacao(index) {
      this.exibirFaturamentoEditarAdicoesDeclaracaoImportacao = index;
      this.indexFaturamentoAdicoesDeclaracaoImportacao = index;
      this.adicoesDeclaracaoImportacaoAtual = this.refDI.adi[index];
      this.modalFaturamentoEditarAdicoesDeclaracaoImportacao(true);
    },
    removerFaturamentoAdicoesDeclaracaoImportacao(index) {
      this.loadingAdicoes = true;
      this.refDI.adi.splice(index, 1);
      toast.success("Registro removido com sucesso!", { timeout: 2000 });
      this.loadingAdicoes = false;
    },
    adicionarAdicoesDeclaracaoImportacao(refADI) {
      this.refDI.adi.push(refADI);
      setTimeout(MenuComponent.reinitialization, 500);
      toast.success("Registro adicionado com sucesso!", { timeout: 2000 });
    },
    editarAdicoesDeclaracaoImportacao(refDI, index) {
      this.refDI.adi[index] = refDI;
      toast.success("Registro atualizado com sucesso!", { timeout: 2000 });
    },
  },
  mounted() {
    if (this.index >= 0) {
      this.refDI = JSON.parse(JSON.stringify(this.refDIFaturamento));
    } else {
      this.refDI = JSON.parse(JSON.stringify(refDIInicializado));
    }
    this.errosValidacao = {};
    this.$utils.requestFocus("txtnDI");
  },
  data() {
    return {
      errosValidacao: [],
      loading: false,
      loadingAdicoes: false,
      exibirFaturamentoEditarAdicoesDeclaracaoImportacao: false,
      indexFaturamentoAdicoesDeclaracaoImportacao: -1,
      adicoesDeclaracaoImportacaoAtual: {},
      refDI: JSON.parse(JSON.stringify(refDIInicializado)),
      options: {
        locale: "pt-BR",
        currency: "BRL",
        currencyDisplay: "hidden",
        precision: 2,
        hideCurrencySymbolOnFocus: false,
        hideGroupingSeparatorOnFocus: false,
        hideNegligibleDecimalDigitsOnFocus: false,
        autoDecimalDigits: true,
        autoSign: true,
        useGrouping: true,
        accountingSign: false,
      },
    };
  },
};
</script>

<style></style>
